// Load CSS
import './main.scss';

// Import files
import * as animations from '@automator/animations';
import * as utilities from '@automator/utilities';

import '@automator/components';

// Export it
window._uo = utilities.isDefined( window._uo ) ? window._uo : {};
window._uo.animation = animations;
window._uo.utility = utilities;